import { render, staticRenderFns } from "./cap-fornecedores.vue?vue&type=template&id=533f5838&"
import script from "./cap-fornecedores.vue?vue&type=script&lang=js&"
export * from "./cap-fornecedores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports